@for (status of statuses; track status.phoneType) {
<span class="phone-type-icon">
   @if (svgIconFor(status); as svgIcon) {
   <mat-icon
      class="svg-icon"
      [ngClass]="stateFor(status)"
      [svgIcon]="svgIcon"
      [matTooltip]="tooltipFor(status)"
   ></mat-icon>
   } @else {
   <mat-icon [ngClass]="stateFor(status)" [matTooltip]="tooltipFor(status)">{{ iconFor(status) }}</mat-icon>
   } @if (status.sipUserCount > 1) {
   <span class="count-badge">{{ status.sipUserCount }}</span>
   }
</span>
}
